"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var HeaderContainer_1 = require("./HeaderContainer");
var mobx_react_1 = require("mobx-react");
var owa_filepicker_options_view_1 = require("owa-filepicker-options-view");
var React = require("react");
var styles = require('./StorageAccountsListView.scss');
var StorageAccountsListView = /** @class */ (function (_super) {
    tslib_1.__extends(StorageAccountsListView, _super);
    function StorageAccountsListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StorageAccountsListView.prototype.render = function () {
        var _this = this;
        return (React.createElement(HeaderContainer_1.default, { className: styles.container, header: this.props.header },
            React.createElement("div", null, this.props.storageAccounts.map(function (storageAccount) {
                var removeHandler = _this.props.onRemoveHandler &&
                    (function () { return _this.props.onRemoveHandler(storageAccount); });
                return (React.createElement("div", { key: storageAccount.model.Id, className: styles.storageAccount },
                    React.createElement(owa_filepicker_options_view_1.FileProviderView, { providerType: storageAccount.type, providerName: storageAccount.name, displayText: storageAccount.model.AssociatedDataProviderAccountId, onRemoveClicked: removeHandler })));
            }))));
    };
    StorageAccountsListView = tslib_1.__decorate([
        mobx_react_1.observer
    ], StorageAccountsListView);
    return StorageAccountsListView;
}(React.Component));
exports.default = StorageAccountsListView;
//# sourceMappingURL=StorageAccountsListView.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-storage-accounts-option/lib/components/StorageAccountsListView.js
// module id = 4990
// module chunks = 2